// extracted by mini-css-extract-plugin
export default {"auth":"Navigation_auth__UkaJD","sign":"Navigation_sign__GjSti","profile":"Navigation_profile__rqzJP","link":"Navigation_link__so4wi"};